"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var editor_web_1 = require("@21st-night/editor-web");
var ActionButtons_1 = __importDefault(require("../../ActionButtons"));
var Button_1 = __importDefault(require("../../Button"));
exports.useStyles = styles_1.makeStyles(function () { return ({
    root: {
        paddingLeft: 22,
    },
    children: {
        paddingLeft: 32,
    },
}); });
var TodosForm = function (_a) {
    var children = _a.children, classNameProp = _a.className, onSubmit = _a.onSubmit, onClickCancel = _a.onClickCancel, placeholder = _a.placeholder, initialValue = _a.initialValue;
    var classes = exports.useStyles();
    var _b = __read(react_1.useState(initialValue
        ? editor_web_1.deserializeDocument(initialValue)
        : editor_web_1.generateRichTextDocument()), 2), value = _b[0], setValue = _b[1];
    var handleSubmit = react_1.useCallback(function (event) {
        event.preventDefault();
        onSubmit(editor_web_1.serializeDocument(value));
    }, [onSubmit, value]);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.ListItem, { className: clsx_1.default(classes.root, classNameProp) },
            react_1.default.createElement(core_1.ListItemText, { disableTypography: true },
                react_1.default.createElement(editor_web_1.InlineEditor, { autoFocus: true, placeholder: placeholder, value: value, onChange: setValue }),
                react_1.default.createElement(ActionButtons_1.default, { spaced: true, marginTop: true },
                    react_1.default.createElement(Button_1.default, { size: "small", color: "primary", variant: "flat", onClick: handleSubmit }, "Save"),
                    react_1.default.createElement(Button_1.default, { size: "small", onClick: onClickCancel }, "Cancel")))),
        children && react_1.default.createElement("div", { className: classes.children }, children)));
};
exports.default = TodosForm;
//# sourceMappingURL=StudyPlanItemFormContainer.js.map